import { render } from "./MessageMultipleDialog.vue?vue&type=template&id=4cba6b47&scoped=true"
import script from "./MessageMultipleDialog.vue?vue&type=script&lang=js"
export * from "./MessageMultipleDialog.vue?vue&type=script&lang=js"

import "./MessageMultipleDialog.vue?vue&type=style&index=0&id=4cba6b47&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cba6b47"]])

export default __exports__